import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <Container>
        <Row className="footer-content">
          <Col lg={4} md={6} className="footer-about mb-4 mb-md-0">
            <h4>Ajyendra Singh</h4>
            <p>Microsoft Dynamics 365 & Power Platform Expert with 8+ years of experience in customization, configuration, and implementation of business solutions.</p>
            <div className="social-links">
              <a href="https://linkedin.com/in/ajyendra-singh" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://github.com/ajyendrasingh" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub />
              </a>
              <a href="mailto:ajyendrasingh24@gmail.com" aria-label="Email">
                <FaEnvelope />
              </a>
            </div>
          </Col>
          
          <Col lg={4} md={6} className="footer-links mb-4 mb-md-0">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Me</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>
          
          <Col lg={4} md={12} className="footer-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <FaMapMarkerAlt />
                <span>Indore, Madhya Pradesh, India</span>
              </li>
              <li>
                <FaEnvelope />
                <span>ajyendrasingh24@gmail.com</span>
              </li>
              <li>
                <FaPhone />
                <span>+91 7691963979</span>
              </li>
            </ul>
          </Col>
        </Row>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Ajyendra Singh. All Rights Reserved.</p>
          <p className="aws-powered">Powered by AWS Cloud</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;